'use strict';
App.controller('ContactCtrl',['$scope','ngDialog','$stateParams','toastr','ProfessionalService', '$loading', '$state',
    function ($scope,ngDialog,$stateParams,toastr,ProfessionalService, $loading, $state) {

    var viewModel = this;
    viewModel.isDetailsSubmitted = false;
    viewModel.userMessage = '';
    
    this.$onInit = async function (){
        try {
            $loading.start('contactPageLink');
            console.log("Sending details to recruiter");
            const data = await ProfessionalService.contactMe($stateParams.userId, {message: viewModel.userMessage, organization: $stateParams.orgId || ''});
            $scope.$apply();
            var stateData = { userName: $stateParams.name, userId: $stateParams.userId, coBrandedUrl: $stateParams.coBrandedUrl };
            $state.go('contactme', stateData);
        } catch (e) {
            toastr.error(e.message);
        } finally {
            viewModel.isDetailsSubmitted = true;
            $loading.finish('contactPageLink');
        }
    }
}]);
